import { combineReducers } from "redux";

import userReducer from "./users/reducer";
import adminReducer from "./admin/reducer";
import notificationReducer from "./notification/reducer";

const reducers = combineReducers({
  userReducer,
  adminReducer,
  notificationReducer,
});

export default reducers;
